/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';

import SubmitButton from '../../components/buttons/SubmitButton/';
import { BaselineActions } from '../../actions/baseline';
import { validateAndDispatch } from '../../helpers/form';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import InputField from '../form/InputField';
import { projectTimezoneIdSelector } from '../../reducers/projects';
import { timezonesSelector, getTimezoneOffset } from '../../reducers/timezones';
import { formatDate } from '../../helpers/timezone';
// import {
//   timeZoneHelperSelector,
// } from '../types/TimeZone/TimeZoneHelpers';

const timezoneOffsetSelector = state => {
  const timezones = timezonesSelector(state);
  const projectTimezoneId = projectTimezoneIdSelector(state);
  return getTimezoneOffset(timezones, projectTimezoneId);
};

const currentProjectIdSelector = (state) => state.projects.get('currentProjectId');
const baseLineForm = (state) => {
  const selector = formValueSelector('createBaseline');
  return selector(state, 'baseLineName');
};

const BaseLineSelector = immutableCreatorSelector(
  [
    currentProjectIdSelector,
    baseLineForm,
    timezoneOffsetSelector,
    // timeZoneHelperSelector,
  ],
  (
    currentProjectId,
    baseLine,
    timezoneOffset,
    // timeZoneHelper,
  ) => ({
    currentProjectId,
    baseLine,
    initialValues: {
      baseLineName: formatDate(timezoneOffset, moment(), 'MMMM DD, YYYY, h:mm:ss A'),
      // baseLineName: timeZoneHelper.formatDate(moment(), 'MMMM DD, YYYY, h:mm:ss A'),
    },
  })
);

@connect(BaseLineSelector)
@reduxForm({
  form: 'createBaseline',
  destroyOnUnmount: true,
})
export default class CreateBaseLineModal extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    // form: PropTypes.instanceOf(Map).isRequired,
    // notifications: PropTypes.instanceOf(Map).isRequired,
    // submitting: PropTypes.bool.isRequired,
    // elementTypes: PropTypes.instanceOf(Map).isRequired,
    // currentElementType: PropTypes.string,
    // activeProp: PropTypes.string,
    // router: PropTypes.object.isRequired,
  }

  submit = (values, dispatch) => {
    const {
      reset,
      currentProjectId,
    } = this.props;

    const baseLineObject = {
      project_id: currentProjectId,
      name: values.baseLineName,
    };

    const validation = {
      baseLineName: [{ rule: 'required', label: 'baseline name' }],
    };

    return validateAndDispatch(
      dispatch,
      BaselineActions.createBaseLine(currentProjectId, baseLineObject),
      validation,
      values
    ).then(() => {
      reset();
    });
  }

  render() {
    const {
      handleSubmit,
      submitting,
    } = this.props;

    return (
      <div className="fs-modal-content">
        <h4>Create Baseline</h4>
        <form>
          <div className="modal-form-wrapper">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Name</label>
              <div className="col-sm-9 mb-2">
                <Field
                  name="baseLineName"
                  type="input"
                  component={InputField}
                  className="form-control"
                  placeholder="Baseline Name"
                  autoFocus
                />
              </div>
            </div>
          </div>
          <div className="modal-form-button-wrapper">
            <SubmitButton
              className="modal-submit-btn"
              submitting={submitting}
              onClick={handleSubmit(this.submit)}
            >Create</SubmitButton>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateBaseLineModal.js